import { call, put } from "redux-saga/effects";

import {
  fetchRetailAdjustmentsData,
  fetchRetailAdjustmentsDataSuccess,
  fetchRetailAdjustmentsDataError,
} from "../modules/retailAdjustments";
import { getRetailAdjustmentsData } from "../end-points/retailAdjustments";
import { transformFilterOptions } from "../../utils/formatFilterOptions";
import { ISuccessResponse } from "../../types/response.types";
import { IRetailAdjustment } from "../../types/retailAdjustments.types";

interface IRetailAdjustmentsData {
  getRetailAdjustments: {
    adjustments: IRetailAdjustment[];
  };
}

export function* getRetailAdjustmentsDataSaga(
  action: ReturnType<typeof fetchRetailAdjustmentsData>,
) {
  const { filters } = action.value;
  try {
    const response: ISuccessResponse<IRetailAdjustmentsData> = yield call(
      getRetailAdjustmentsData,
      transformFilterOptions(filters),
    );
    const data = response.data.getRetailAdjustments.adjustments || [];
    yield put(fetchRetailAdjustmentsDataSuccess(data));
  } catch (error) {
    console.log("getRetailAdjustmentsDataSaga Error:", error);
    yield put(fetchRetailAdjustmentsDataError());
  }
}
